import { SHOW_FILTER_MODAL } from '../../constant';

export const showFilter = () => (dispatch) =>
  dispatch({
    type: SHOW_FILTER_MODAL,
    filterModalProps: { open: true },
  });
